import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

let brand = store.getters.getBrandData()
if (brand && brand.contactInfo && brand.contactInfo.companyNameShort) {
  document.title = brand.contactInfo.companyNameShort + ' Dnc, Dns, Data portability, View and Delete request form'
} else {
  document.title = 'DMS Dnc, Dns, Data portability, View and Delete request form'
}

let icon = document.getElementById('favicon')
let shortcuticon = document.getElementById('shortcut-icon')
if (brand && brand.images && brand.images.favicon) {
  icon.href = brand.images.favicon
  shortcuticon.href = brand.images.favicon
} else {
  icon.href = 'https://digitalmediasolutions.com/themes/dms/assets/images/favicon.png'
  shortcuticon.href = 'https://digitalmediasolutions.com/themes/dms/assets/images/favicon.png'
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: () => import(/* webpackChunkName: "confirmation" */ './views/Confirmation.vue')
    },
    {
      path: '/verify',
      name: 'verify',
      component: () => import(/* webpackChunkName: "verify" */ './views/Verify.vue')
    },
    {
      path: '/request',
      name: 'request',
      component: () => import(/* webpackChunkName: "request" */ './views/Request.vue')
    },
    {
      path: '/info',
      name: 'info',
      component: () => import(/* webpackChunkName: "info" */ './views/Info.vue')
    },
    {
      path: '/done',
      name: 'done',
      component: () => import(/* webpackChunkName: "done" */ './views/Done.vue')
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import(/* webpackChunkName: "compliance" */ './views/Compliance.vue')
    },
    {
      path: '/privacy*',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "compliance" */ './views/Compliance.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "logout" */ './views/Logout.vue')
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import(/* webpackChunkName: "logout" */ './views/Partners.vue')
    }
  ]
})
